<!-- <ngx-loading-bar
  [color]="'#84A7CD'"
  [includeSpinner]="false"
  [height]="'4px'"
></ngx-loading-bar> -->
<!-- <shared-loader></shared-loader> -->
<shared-tap-to-top></shared-tap-to-top>
<router-outlet></router-outlet>
